import {Part} from 'biojs/Part';
import Annotation from 'molbio/annotations/backbone/Annotation';
import CutSite from 'molbio/enzymes/backbone/CutSite';
import SequencePrimer from 'molbio/primers/backbone/SequencePrimer';
import TranslationAsAnnotation from 'molbio/translations/backbone/TranslationAsAnnotation';

export type Labelable = Annotation | CutSite | TranslationAsAnnotation | Part | SequencePrimer;

export enum LabelOrientation {
  RIGHTSIDE_UP = 'RIGHTSIDE_UP',
  UPSIDE_DOWN = 'UPSIDE_DOWN',
}

export interface AngledText {
  angle: number;
  orientation: LabelOrientation | null;
}

export interface GenericArcDatum {
  startAngle: number;
  endAngle: number;
}
